import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/hooks/hook";
import { Package } from "@/interfaces/Package";
import { GET } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import PackageTable from "./PackageTable";
import DashboardHeader from "@/components/DashboardHeader";
import { Link } from "react-router-dom";

const PackagesPage = () => {
  const { packages } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { business_id } = useAppSelector((store) => store.user);
  const [searchQuery, setSearchQuery] = useState("");
  const [packageList, setPackagesList] = useState<Package[]>([]);
  useEffect(() => {
    (async () => {
      try {
        const result = await GET(`${packages}/${business_id}`, refreshToken);
        setPackagesList(result.data);
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const filteredPackage = Array.isArray(packageList)
  ? packageList.filter((item) => {
      // in order to search by company and admin name using search query
      const name = item.name.toLowerCase();
      const itemName = item.name.toLowerCase();
      const search = searchQuery.toLowerCase();
      return name.includes(search) || itemName.includes(search);
    })
  : [];
  return (
    <div>
      <div className="">
        <DashboardHeader width="w-full" title="Packages">
          <div className="flex items-center gap-3 flex-wrap md:flex-nowrap mt-2 md:mt-0 ">
            <input
              type="text"
              placeholder="Search Package Name"
              onChange={handleSearch}
              className="w-full md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              name=""
              id=""
            />
            <Link to='/packages/new' className="bg-black text-white  rounded-full py-2 px-6 min-w-36">
              {" "}
              <span className="text-lg">+</span> Add New
            </Link>
          </div>
        </DashboardHeader>

        <PackageTable packageList={filteredPackage} />
      </div>
    </div>
  );
};

export default PackagesPage;
